import React from 'react';
import PropTypes from 'prop-types';
import { DraggableCore } from 'react-draggable';

import { ptToPx, pxToPt } from '../../../util';

import './TextLayer.less';

import moveIcon from '../../../../assets/images/invitations/move_icon_green_button.svg';

// consider using React.PureComponent if performance seems to be dragging
class DraggableLayer extends React.Component {
  constructor(props) {
    super(props);

    this.handleDragStart = this.handleDragStart.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleDragStop = this.handleDragStop.bind(this);

    this.state = {
      dragging: false,
      dragHandle: null,
      dragDirection: {
        top: false,
        right: false,
        bottom: false,
        left: false,
      },
      deltas: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      },
    };
  }

  handleDragStart(e, dragHandle, dragDirection) {
    e.preventDefault();
    e.stopPropagation();
    this.setState(prevState => ({
      dragging: true,
      dragHandle,
      dragDirection: dragDirection
        ? { ...prevState.dragDirection, ...dragDirection }
        : prevState.dragDirection,
    }));
  }

  handleDrag(e, position) {
    e.preventDefault();
    e.stopPropagation();
    const { element, parentDimensions, elementRef, isFoldable } = this.props;
    const { dragHandle, dragDirection, deltas } = this.state;

    const width = element.width - pxToPt(deltas.left) - pxToPt(deltas.right);
    const height = element.height - pxToPt(deltas.bottom) - pxToPt(deltas.top);
    const top = isFoldable
      ? element.y - parentDimensions.height + pxToPt(deltas.top)
      : element.y + pxToPt(deltas.top);
    const left = element.x + pxToPt(deltas.left);
    const right = parentDimensions.width - (left + width);
    const bottom = parentDimensions.height - (top + height);
    const nextDeltas = {
      ...deltas,
    };
    if (dragHandle === 'DRAG_NESW') {
      // logic for validating an element being moved is different than logic for element being
      // resized, it's important to ensure that dimensions of element stay the same
      if ((left > 0 || position.deltaX > 0) && (right > 0 || position.deltaX < 0)) {
        nextDeltas.left = deltas.left + position.deltaX;
        nextDeltas.right = deltas.right - position.deltaX;
      } else if (left < 0) {
        nextDeltas.left = deltas.left - ptToPx(left);
        nextDeltas.right = deltas.right + ptToPx(left);
      } else if (right < 0) {
        nextDeltas.left = deltas.left + ptToPx(right);
        nextDeltas.right = deltas.right - ptToPx(right);
      }
      if ((top > 0 || position.deltaY > 0) && (bottom > 0 || position.deltaY < 0)) {
        nextDeltas.top = deltas.top + position.deltaY;
        nextDeltas.bottom = deltas.bottom - position.deltaY;
      } else if (top < 0) {
        nextDeltas.top = deltas.top - ptToPx(top);
        nextDeltas.bottom = deltas.bottom + ptToPx(top);
      } else if (bottom < 0) {
        nextDeltas.top = deltas.top + ptToPx(bottom);
        nextDeltas.bottom = deltas.bottom - ptToPx(bottom);
      }
    } else {
      // when resizing, each of the following conditions ensures that the element stays
      // within the bounds of the card, and that the element dimensions of the element
      // remain greater than the dimensions of the elements content
      if (dragDirection.top) {
        if (position.deltaY > 0) {
          if (ptToPx(height) > elementRef.offsetHeight) {
            nextDeltas.top = deltas.top + position.deltaY;
          } else if (ptToPx(height) < elementRef.offsetHeight) {
            nextDeltas.top = deltas.top - (elementRef.offsetHeight - ptToPx(height));
          }
        } else if (position.deltaY < 0) {
          if (top > 0) {
            nextDeltas.top = deltas.top + position.deltaY;
          } else if (top < 0) {
            nextDeltas.top = deltas.top - ptToPx(top);
          }
        }
      }
      if (dragDirection.bottom) {
        if (position.deltaY > 0) {
          if (bottom > 0) {
            nextDeltas.bottom = deltas.bottom - position.deltaY;
          } else if (bottom < 0) {
            nextDeltas.bottom = deltas.bottom - ptToPx(bottom);
          }
        } else if (position.deltaY < 0) {
          if (ptToPx(height) > elementRef.offsetHeight) {
            nextDeltas.bottom = deltas.bottom - position.deltaY;
          } else if (ptToPx(height) < elementRef.offsetHeight) {
            nextDeltas.bottom = deltas.bottom - (elementRef.offsetHeight - ptToPx(height));
          }
        }
      }
      if (dragDirection.right) {
        if (position.deltaX > 0) {
          if (right > 0) {
            nextDeltas.right = deltas.right - position.deltaX;
          } else if (right < 0) {
            nextDeltas.right = deltas.right - ptToPx(right);
          }
        } else if (position.deltaX < 0) {
          if (ptToPx(width) > elementRef.offsetWidth) {
            nextDeltas.right = deltas.right - position.deltaX;
          } else if (ptToPx(width) < elementRef.offsetWidth) {
            nextDeltas.right = deltas.right - (elementRef.offsetWidth - ptToPx(width));
          }
        }
      }
      if (dragDirection.left) {
        if (position.deltaX > 0) {
          if (ptToPx(width) > elementRef.offsetWidth) {
            nextDeltas.left = deltas.left + position.deltaX;
          } else if (ptToPx(width) < elementRef.offsetWidth) {
            nextDeltas.left = deltas.left - (elementRef.offsetWidth - ptToPx(width));
          }
        } else if (position.deltaX < 0) {
          if (left > 0) {
            nextDeltas.left = deltas.left + position.deltaX;
          } else if (left < 0) {
            nextDeltas.left = deltas.left - ptToPx(left);
          }
        }
      }
    }
    // after all validation is done, update component state with the new deltas
    this.setState({
      deltas: nextDeltas,
    });
  }

  handleDragStop(e) {
    e.preventDefault();
    e.stopPropagation();
    const { dragStopCallback } = this.props;
    const { deltas } = this.state;
    if (dragStopCallback) {
      // if dragStopCallback is passed in, invoke with deltas supplied as the argument
      // so that updates can be made to the backend
      dragStopCallback(deltas);
    }
    // reset component state to its initial state
    this.setState({
      dragging: false,
      dragHandle: null,
      dragDirection: {
        top: false,
        right: false,
        bottom: false,
        left: false,
      },
      deltas: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
    });
  }

  render() {
    const {
      element,
      style,
      className,
      isActive,
      parentDimensions,
      disabled,
      children,
      isFoldable,
    } = this.props;
    const { deltas, dragHandle, dragDirection, dragging } = this.state;

    const { x, y, width, height } = element;

    const dragHandlers = {
      onDrag: this.handleDrag,
      onStop: this.handleDragStop,
    };
    // all drag handles need to be shifted depending on the width of the drag handle,
    // this variable makes it easy to update the shift in one spot
    const dragHandleWidth = 10;
    // console.log(this.state.dragDirection);

    if (disabled) {
      // if disabled prop is true, just wrap in div so that positioning/styles can be applied
      // and render children. deltas, dragging, and dragHandle will all be in their default state
      return (
        <div style={style} className={className}>
          {children(deltas, dragging, dragHandle)}
        </div>
      );
    }
    return (
      <div style={style} className={className}>
        {/* children must be a function */}
        {children(deltas, dragging, dragHandle)}
        {/* drag move nesw */}
        {isActive && (
          <DraggableCore
            {...dragHandlers}
            onStart={e =>
              this.handleDragStart(e, 'DRAG_NESW', {
                top: true,
                right: true,
                bottom: true,
                left: true,
              })
            }
          >
            <span className="element-drag-handle">
              <img
                src={moveIcon}
                className="zolaicon zolaicon-move element-drag-handle__icon"
                style={{
                  position: 'absolute',
                  left: `${ptToPx(width / 2) - 10.5}px`,
                  top: '-35px',
                  width: '21px',
                  height: '21px',
                  color: 'white',
                  backgroundColor: '#01b4c0',
                  border: '2px solid white',
                  borderRadius: '100%',
                  cursor: 'move',
                  lineHeight: 1.3,
                  fontSize: '12px',
                  transform: `translate(${(deltas.left - deltas.right) / 2}px, ${deltas.top}px)`,
                  zIndex: 1000,
                }}
                alt="move element icon"
              />
              <span
                className="element-drag-handle__line"
                style={{
                  position: 'absolute',
                  left: `${ptToPx(width / 2) - 0.5}px`,
                  top: '-20px',
                  width: '1px',
                  height: '20px',
                  backgroundColor: '#01b4c0',
                  transform: `translate(${(deltas.left - deltas.right) / 2}px, ${deltas.top}px)`,
                }}
              />
            </span>
          </DraggableCore>
        )}
        {/* drag resize n */}
        {isActive && (
          <DraggableCore
            {...dragHandlers}
            onStart={e => this.handleDragStart(e, 'TOP_RESIZE', { top: true })}
          >
            <span
              className={`element-resize-handle element-resize-handle--top ${
                dragHandle === 'TOP_RESIZE' ? 'element-resize-handle--active' : ''
              }`}
              style={{
                top: `${-dragHandleWidth}px`,
                left: `${ptToPx(width / 2) - dragHandleWidth / 2}px`,
                cursor: 'ns-resize',
                transform: `translate(${(deltas.left - deltas.right) / 2}px, ${deltas.top}px)`,
              }}
            />
          </DraggableCore>
        )}
        {/* drag resize e */}
        {isActive && (
          <DraggableCore
            {...dragHandlers}
            onStart={e => this.handleDragStart(e, 'RIGHT_RESIZE', { right: true })}
          >
            <span
              className={`element-resize-handle element-resize-handle--right ${
                dragHandle === 'RIGHT_RESIZE' ? 'element-resize-handle--active' : ''
              }`}
              style={{
                top: `${ptToPx(height / 2) - dragHandleWidth / 2}px`,
                right: `${-dragHandleWidth}px`,
                cursor: 'ew-resize',
                transform: `translate(${-deltas.right}px, ${(deltas.top - deltas.bottom) / 2}px)`,
              }}
            />
          </DraggableCore>
        )}
        {/* drag resize s */}
        {isActive && (
          <DraggableCore
            {...dragHandlers}
            onStart={e => this.handleDragStart(e, 'BOTTOM_RESIZE', { bottom: true })}
          >
            <span
              className={`element-resize-handle element-resize-handle--bottom ${
                dragHandle === 'BOTTOM_RESIZE' ? 'element-resize-handle--active' : ''
              }`}
              style={{
                left: `${ptToPx(width / 2) - 5}px`,
                bottom: `${-dragHandleWidth}px`,
                cursor: 'ns-resize',
                transform: `translate(${(deltas.left - deltas.right) / 2}px, ${-deltas.bottom}px)`,
              }}
            />
          </DraggableCore>
        )}
        {/* drag resize w */}
        {isActive && (
          <DraggableCore
            {...dragHandlers}
            onStart={e => this.handleDragStart(e, 'LEFT_RESIZE', { left: true })}
          >
            <span
              className={`element-resize-handle element-resize-handle--left ${
                dragHandle === 'LEFT_RESIZE' ? 'element-resize-handle--active' : ''
              }`}
              style={{
                top: `${ptToPx(height / 2) - dragHandleWidth / 2}px`,
                left: `${-dragHandleWidth}px`,
                cursor: 'ew-resize',
                transform: `translate(${deltas.left}px, ${(deltas.top - deltas.bottom) / 2}px)`,
              }}
            />
          </DraggableCore>
        )}
        {/* drag resize nw */}
        {isActive && (
          <DraggableCore
            {...dragHandlers}
            onStart={e => this.handleDragStart(e, 'TOP_LEFT_RESIZE', { top: true, left: true })}
          >
            <span
              className={`element-resize-handle ${
                dragHandle === 'TOP_LEFT_RESIZE' ? 'element-resize-handle--active' : ''
              }`}
              style={{
                left: `${-dragHandleWidth}px`,
                top: `${-dragHandleWidth}px`,
                cursor: 'nwse-resize',
                transform: `translate(${deltas.left}px, ${deltas.top}px)`,
              }}
            />
          </DraggableCore>
        )}
        {/* drag resize ne */}
        {isActive && (
          <DraggableCore
            {...dragHandlers}
            onStart={e => this.handleDragStart(e, 'TOP_RIGHT_RESIZE', { top: true, right: true })}
          >
            <span
              className={`element-resize-handle ${
                dragHandle === 'TOP_RIGHT_RESIZE' ? 'element-resize-handle--active' : ''
              }`}
              style={{
                top: `${-dragHandleWidth}px`,
                right: `${-dragHandleWidth}px`,
                cursor: 'nesw-resize',
                transform: `translate(${-deltas.right}px, ${deltas.top}px)`,
              }}
            />
          </DraggableCore>
        )}
        {/* drag resize sw */}
        {isActive && (
          <DraggableCore
            {...dragHandlers}
            onStart={e =>
              this.handleDragStart(e, 'BOTTOM_LEFT_RESIZE', { bottom: true, left: true })
            }
          >
            <span
              className={`element-resize-handle ${
                dragHandle === 'BOTTOM_LEFT_RESIZE' ? 'element-resize-handle--active' : ''
              }`}
              style={{
                left: `${-dragHandleWidth}px`,
                bottom: `${-dragHandleWidth}px`,
                cursor: 'nesw-resize',
                transform: `translate(${deltas.left}px, ${-deltas.bottom}px)`,
              }}
            />
          </DraggableCore>
        )}
        {/* drag resize se */}
        {isActive && (
          <DraggableCore
            {...dragHandlers}
            onStart={e =>
              this.handleDragStart(e, 'BOTTOM_RIGHT_RESIZE', { bottom: true, right: true })
            }
          >
            <span
              className={`element-resize-handle ${
                dragHandle === 'BOTTOM_RIGHT_RESIZE' ? 'element-resize-handle--active' : ''
              }`}
              style={{
                bottom: `${-dragHandleWidth}px`,
                right: `${-dragHandleWidth}px`,
                cursor: 'nwse-resize',
                transform: `translate(${-deltas.right}px, ${-deltas.bottom}px)`,
              }}
            />
          </DraggableCore>
        )}

        {/* top offset measure */}
        {isActive && dragging && dragDirection.top && (
          <span
            className="coordinate-line coordinate-line--vertical"
            style={{
              top: isFoldable ? `-${y - parentDimensions.height}pt` : `-${y}pt`,
              left: `${(ptToPx(width) + (deltas.left - deltas.right)) / 2}px`,
              height: isFoldable
                ? `${y + pxToPt(deltas.top) - parentDimensions.height}pt`
                : `${y + pxToPt(deltas.top)}pt`,
            }}
          >
            <span className="coordinate-line__value">
              {isFoldable
                ? Math.round(y + pxToPt(deltas.top) - parentDimensions.height)
                : Math.round(y + pxToPt(deltas.top))}
              pt
              {/* {Math.round((y + pxToPt(deltas.top)) - parentDimensions.height)}pt */}
            </span>
          </span>
        )}
        {/* bottom offset measure */}
        {isActive && dragging && dragDirection.bottom && (
          <span
            className="coordinate-line coordinate-line--vertical"
            style={{
              bottom: isFoldable
                ? `-${parentDimensions.height - (y + height) + parentDimensions.height}pt`
                : `-${parentDimensions.height - (y + height)}pt`,
              left: `${(ptToPx(width) + (deltas.left - deltas.right)) / 2}px`,
              height: isFoldable
                ? `${
                    parentDimensions.height -
                    (y + height) +
                    pxToPt(deltas.bottom) +
                    parentDimensions.height
                  }pt`
                : `${parentDimensions.height - (y + height) + pxToPt(deltas.bottom)}pt`,
            }}
          >
            <span className="coordinate-line__value">
              {isFoldable
                ? Math.round(
                    parentDimensions.height -
                      (y + height) +
                      pxToPt(deltas.bottom) +
                      parentDimensions.height
                  )
                : Math.round(parentDimensions.height - (y + height) + pxToPt(deltas.bottom))}
              pt
              {/* {Math.round((parentDimensions.height - (y + height)) + pxToPt(deltas.bottom) + parentDimensions.height)}pt */}
            </span>
          </span>
        )}
        {/* left offset measure */}
        {isActive && dragging && dragDirection.left && (
          <span
            className="coordinate-line coordinate-line--horizontal"
            style={{
              top: `${(ptToPx(height) + (deltas.top - deltas.bottom)) / 2}px`,
              left: `-${x}pt`,
              width: `${x + pxToPt(deltas.left)}pt`,
            }}
          >
            <span className="coordinate-line__value">{Math.round(x + pxToPt(deltas.left))}pt</span>
          </span>
        )}
        {/* right offset measure */}
        {isActive && dragging && dragDirection.right && (
          <span
            className="coordinate-line coordinate-line--horizontal"
            style={{
              top: `${(ptToPx(height) + (deltas.top - deltas.bottom)) / 2}px`,
              right: `-${parentDimensions.width - (x + width)}pt`,
              width: `${parentDimensions.width - (x + width) + pxToPt(deltas.right)}pt`,
            }}
          >
            <span className="coordinate-line__value">
              {Math.round(parentDimensions.width - (x + width) + pxToPt(deltas.right))}pt
            </span>
          </span>
        )}
      </div>
    );
  }
}

DraggableLayer.propTypes = {
  element: PropTypes.shape({}),
  className: PropTypes.string,
  style: PropTypes.shape({}),
  isActive: PropTypes.bool,
  parentDimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  dragStopCallback: PropTypes.func,
  elementRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  disabled: PropTypes.bool,
  children: PropTypes.func,
  isFoldable: PropTypes.bool,
};

export default DraggableLayer;
